import React, { useContext } from 'react';
import { AuthContext } from '../../context/auth';
import Header from '../../components/Header';
import Barra from '../../components/barra';
import MenuComprasyAlmacen from '../../components/comprasyalmacen/MenuComprasyAlmacen';
import Footer from '../../components/Footer';
import TablaOrdenCompra from '../../components/comprasyalmacen/tablaOrdenCompra';



function OrdenCompra() {

  const { user } = useContext(AuthContext);
  let op = require('../../../src/modulos/datos');

  return (

    user && (

      <div style={{ height: "100vh", padding: 0 }}>
        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
          <Header />
        </div>
        <div className="row col-md-12" style={{ height: "85%", padding: 0, margin: 0 }}>
          <div className="col-md-12" style={{ height: "100%", padding: 0 }}>
            <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
              <MenuComprasyAlmacen/>
            </div>
            <div className="col-md-12" style={{ height: "90%", padding: 0 }}>
              <TablaOrdenCompra />
            </div>
          </div>
        </div>
        <div  className="col-md-12" style={{ height: "5%", padding: 0 }}>
           <Footer />
        </div>
      </div>

    )


  );
}


export default OrdenCompra;
